/**
 * Charge de manière différée la carte BienIci.
 */
export default class MapBienIci {
    constructor($view) {
        this.$view = $view;

        // Paramètres de la carte
        this.latitude = $view.data('lat');
        this.longitude = $view.data('lng');
        this.id = $view.attr('id');
        this.sunPositionSelector = parseInt($view.data('sunPositionSelector') || 0);
        this.positionRandomly = parseInt($view.data('positionRandomly'));
        this.zoom = $view.data('zoom') || 16;
        this.apiKey = $view.data('bieniciApiKey');

        this.mapLoader = $view.next('.mapLoader').get(0);
        this.$markers = $('gmap-marker');
        this.markers = [];

        this.scripts = this.getScripts();
        this.bienIciScriptsLoaded = false;
        this.countLoadedScripts = 0;

        this.bind();
    }

    bind() {
        this.watch();
    }

    /**
     * Écoute les événements du composant.
     * @return {void}
     */
    watch() {
        /*
         * Pour ne pas pénaliser les performances de la page,
         * les scripts ne seront chargés que si le composant est
         * visible dans le navigateur.
         * On fait donc une vérification à chaque fin de scroll,
         * et aussi à la fin du chargement du DOM pour les cas où
         * la page aurait été actualisée avec la div visible).
         */
        document.addEventListener('DOMContentLoaded', this.loadScripts.bind(this));
        document.addEventListener('scrollend', this.loadScripts.bind(this));
    }

    /**
     * Charge en asynchrône l'API ReCaptcha.
     * @return {void}
     */
    loadScripts() {
        if (this.bienIciScriptsLoaded || ! this.isInViewport(this.$view.get(0))) {
            return;
        }

        this.bienIciScriptsLoaded = true;
        document.removeEventListener('scrollend', this.loadScripts);
        document.removeEventListener('DOMContentLoaded', this.loadScripts);

        // Affiche le loader
        if (this.mapLoader) {
            this.mapLoader.style.display = "flex";
        }

        // Chargement des scripts
        for (var i = 0; i < this.scripts.length; i++) {
            var script = document.createElement('script');
            script.src = this.scripts[i].src ? this.scripts[i].src : null;
            script.type = this.scripts[i].type ? this.scripts[i].type : null;
            script.async = true;
            script.onload = this.checkAllScriptLoaded.bind(this);
            if (this.scripts[i].crossorigin) {
                script.setAttribute('crossorigin', this.scripts[i].crossorigin);
            }
            if (this.scripts[i].dataF4map) {
                script.setAttribute('data-f4map', this.scripts[i].dataF4map);
            }
            document.head.appendChild(script);
        }
    }

    /**
     * Vérifie que tous les scripts soient bien chargés avant de lancer l'initialisation.
     */
    checkAllScriptLoaded() {
        ++this.countLoadedScripts;
        if (this.countLoadedScripts === this.scripts.length) {
            this.initialize();
        }
    }

    /**
     * Initialise la carte avec l'API bienici.com
     */
    initialize() {

        if (this.mapLoader) {
            this.mapLoader.style.display = "none";
        }

        this.bounds = new f4.map.LatLngBounds();

        let mapOptions = {
            zoom: this.zoom,
            lon: this.longitude,
            lat: this.latitude,
            //disableDefaultUI: false,
            container: "#"+this.id,
            draggableTouch: true, // Pour activer la manipulation de la carte en tactile (par défaut la carte n'est pas
            // manipulable en tactile pour ne pas interférer avec le défilement de la page)
            scrollwheel: true, // Pour activer le zoom à la molette (par défaut le zoom n'est pas modifiable avec
        };

        // Désactive le bouton pour choisir l'ensoleillement
        if ( ! this.sunPositionSelector) {
            mapOptions.sunPositionSelector = false;
        }

        this.map = kimono.addMap(mapOptions);

        this.map.on("load", this.onLoadMap.bind(this));
    }

    onLoadMap(realEstateAd, map) {
        this.addMarkers(map);
        map.panTo(new f4.map.LatLng(
            parseFloat(this.latitude),
            parseFloat(this.longitude)
        ));
        map.setZoom(this.zoom);
    }

    addMarkers(map) {
        // Nettoie les anciens marqueurs
        if(this.markers.length > 0) {
            for (var i = 0; i < this.markers.length; i++ ) {
                this.markers[i].setMap(null);
            }
            this.markers.length = 0;
        }
        this.markers = [];

        // Ajoute les marqueurs
        this.$markers.toArray().forEach((item) => {
            let $item = $(item);
            if ($item.attr('latitude') !== undefined && $item.attr('longitude') !== undefined) {
                let latLng = new f4.map.LatLng(
                    parseFloat($item.attr('latitude')),
                    parseFloat($item.attr('longitude'))
                );

                if (this.positionRandomly) {
                    this.markers.push(new f4.map.Circle({
                        strokeColor: '#0000FF',
                        strokeOpacity: 0.35,
                        strokeWeight: 2,
                        fillColor: '#0000FF',
                        fillOpacity: 0.35,
                        map: map,
                        center: latLng,
                        radius: this.positionRandomly
                    }));
                } else {
                    this.markers.push(new f4.map.Marker({
                        position: latLng,
                        map: map,
                        icon: {
                            url: "/frontend/img/icons/ico_map_marker_off.png"
                        }
                    }));
                }

                this.bounds.extend(latLng);
                // this.map.fitBounds(this.bounds);
            }
        });
    }

    /**
     * Détermine si un élément est visible (partiellement) ou non dans le navigateur.
     * @return {boolean}
     */
    isInViewport(el) {
        var rect = el.getBoundingClientRect();

        var topVisible = (
            rect.top >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );

        var bottomVisible = (
            rect.bottom >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );

        var betweenBoth = (
            rect.top < 0 &&
            rect.bottom > (window.innerHeight || document.documentElement.clientHeight)
        );

        return (topVisible || bottomVisible || betweenBoth);
    }

    /**
     * Définition des scripts à charger.
     *
     * @return {({src:string,type:string,crossorigin:undefined|string,dataF4map:undefined|string})[]}
     */
    getScripts() {
        return [
            {
                src:'https://www.bienici.com/api.js?api_key='+this.apiKey,
                type: 'text/javascript',
            },
            {
                src:'https://core.bienici.com/api.js?api_key='+this.apiKey+'&leaflet-compatibility=yes',
                type: 'text/javascript',
                crossorigin: 'anonymous',
                'dataF4map': 'true'
            }
        ];
    }
}
